'use strict';

angular.module('app.newInfluencerDetail', [])

.controller('NewInfluencerDetailsCtrl', function ($scope, $rootScope, $http, $modal, $modalInstance, $window, adminService) {
    
    var definitions = angular.copy($rootScope.definitions);
    $scope.countries = definitions.countries;
    $scope.languages = definitions.languages;
    $scope.goToURL = function(selectedChannel, $event) {
        var platformDomain = null;
        var channelDomain = null;
        var getInfluencerDetailsDomainUrl = $rootScope.apiUrl + 'admin/getPlarformDomainUrl/' + selectedChannel.id;
        $http.get(getInfluencerDetailsDomainUrl, {loader: false})
            .success(function(responseInfluencerDetailsDomainUrl){
                platformDomain = responseInfluencerDetailsDomainUrl.data.domain;   
                channelDomain = responseInfluencerDetailsDomainUrl.channel.handle;
                if(responseInfluencerDetailsDomainUrl.channel.isLinked == 1){
                    if(responseInfluencerDetailsDomainUrl.channel.platform_id == 6) {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + responseInfluencerDetailsDomainUrl.channel.youtubeType.toLowerCase() + '/' + selectedChannel.handle, '_blank');
                    } else {
                        $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + selectedChannel.handle, '_blank');
                    }
                }            
            });
        $event.stopPropagation();                           
    };

    $scope.searchCountries = function(event) {
        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
            for(var i = 0; i < $scope.countries.length; i++) {
                if($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                    var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                    var item = checkbox.find('label')[i];
                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                    break;
                }
            }
        }
    }

    var dismissReasonUrl = $rootScope.apiUrl + 'admin/getDismissReason';
        $http.get(dismissReasonUrl, {loader: false})
            .success(function(response){
                $scope.dismissReasons = response.data;
            })
    

    $scope.channels = [];
    $scope.addNewChannels = [];
    $scope.editChannels = [];
    $scope.tempEditChannels = [];
    $scope.removeChannels = [];
    $scope.hasChannel = null;
    $scope.isValidToAdd = true;
    $scope.enableWatch = false;
    $scope.numberClick = 0;

    var getCurrentInfluencerUrl = $rootScope.apiUrl + 'admin/getCurrentInfluencer?blog_id=' + $scope.id;
    $http.get(getCurrentInfluencerUrl, {loader: false})
        .success(function(responseCurrentInfluencer){
            $scope.InfluencerDetail = responseCurrentInfluencer.data;
            $scope.influencerId = responseCurrentInfluencer.data.id;
            $scope.domain = responseCurrentInfluencer.data.domain;
            $scope.outputLanguage = [];

            var platformTypeUrl = $rootScope.apiUrl + 'admin/getPlatformListForBlog/' + $scope.InfluencerDetail.id;
            $http.get(platformTypeUrl, {loader: false})
                .success(function(responsePlatformType){
                    var tempPlatformList = responsePlatformType.platformList;
                    $scope.InfluencerDetail.platformList = [];
                    $scope.InfluencerDetail.platformList = responsePlatformType.platformList;

                    $scope.countries.forEach(function (valCountry) {
                        if ($scope.InfluencerDetail.country != null) {
                            if (valCountry.id == $scope.InfluencerDetail.country.id) {
                                valCountry.ticked = true;
                                $scope.outputCountry = valCountry;
                            }
                        }
                    })

                    $scope.languages.forEach(function (valLanguage) {
                        $scope.InfluencerDetail.influencerLanguages.forEach(function (item) {
                            if (item.language != null) {
                                if (valLanguage.id == item.language.id) {
                                    valLanguage.ticked = true;
                                    $scope.outputLanguage.push(valLanguage);
                                }
                            }
                        }) 
                    })
   
                    $scope.enableWatch = true;
                })
                .error(function(responsePlatformType){

                })

            $scope.status_icon = adminService.getActiveIcon($scope.InfluencerDetail.isActive);     
            $scope.approval_icon = adminService.getApproveIcon($scope.InfluencerDetail.status);

            var influencerDetailsChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.id;
            $http.get(influencerDetailsChannelUrl, {loader: false})
                .success(function(responseInfluencerDetailsChannel){
                    angular.forEach(responseInfluencerDetailsChannel.data, function(item) {
                        $scope.channels.push(item);
                    })
                    $scope.hasChannel = $scope.channels.length;
                })
          
            $scope.PlatformIcon = function (platform_id) {
                return adminService.getPlatformIcon(platform_id);
            }


    })

    $scope.setSelectedDismissReason = function () {
        $scope.selectedReason = "";
        $scope.dismissReasons.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedReason = val.id;
        });
    }

    $scope.setSelectedCountry = function () {
        $scope.selectedCountry = "";
        $scope.countries.forEach(function (val) {
            if (val.ticked === true) {
                $scope.selectedCountry = val.id;
            }    
        });
    }

    $scope.setSelectedLanguages = function () {
        $scope.selectedLanguages = [];
        $scope.languages.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedLanguages.push(val.id)
        });
    }

    $scope.getNextNewInfluencer = function () {
        $scope.addNewChannels = [];
        $scope.editChannels = [];
        $scope.tempEditChannels = [];
        $scope.removeChannels = [];
        
        //from current index, get next index
        $scope.numberClick = $scope.numberClick + 1;
        $scope.newInfluencerIndex = $scope.newInfluencerIndex + 1;
        var nextNewInfluencerIndex = 0;
        if($scope.newInfluencerIndex < 25 && $scope.currentPage <= $scope.pages){
            nextNewInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.newInfluencerIndex;
            if(nextNewInfluencerIndex >= $scope.number){
                $scope.newInfluencerIndex -= 1;
                nextNewInfluencerIndex = $scope.number;
            }            
        } else if($scope.newInfluencerIndex == 25 && $scope.currentPage < $scope.pages){
            $scope.currentPage += 1;
            $scope.newInfluencerIndex = 0;
            nextNewInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.newInfluencerIndex;
        } else if($scope.newInfluencerIndex == 25 && $scope.currentPage == $scope.pages){
            $scope.newInfluencerIndex = 24;
            nextNewInfluencerIndex = $scope.number;
        }

        nextNewInfluencerIndex = nextNewInfluencerIndex - $scope.numberClick;

        var nextData = {
            selectedPlatform: $scope.selectedPlatform.id
        };

        if (nextNewInfluencerIndex < 0) {
            nextNewInfluencerIndex = 0;
        }
        
        var req = {
            url: $rootScope.apiUrl + 'admin/getNextNewInfluencer/' + nextNewInfluencerIndex,
            method: 'POST',
            data: JSON.stringify(nextData)
        }

        $http(req).success(function (responseNextPendingInfluencer) {
            if (responseNextPendingInfluencer.data == null) {
                $scope.closeModal();
            }
            else {
                $scope.pendingInfluencerDetail = responseNextPendingInfluencer.data;
                $scope.influencerId = responseNextPendingInfluencer.data.id;
                $scope.domain = responseNextPendingInfluencer.data.domain;
                $scope.status_icon = adminService.getActiveIcon($scope.pendingInfluencerDetail.isActive);     
                $scope.approval_icon = adminService.getApproveIcon($scope.pendingInfluencerDetail.status);

                $scope.countries.forEach(function (val) {
                    if ($scope.pendingInfluencerDetail.country != null) {
                        if (val.id == $scope.pendingInfluencerDetail.country.id) {
                            val.ticked = true;
                            $scope.outputCountry = val;
                        }
                    }
                })

                $scope.outputLanguage = [];
                $scope.languages.forEach(function (val) {
                    $scope.pendingInfluencerDetail.influencerLanguages.forEach(function (item) {
                        if (item.language != null) {
                            if (val.id == item.language.id) {
                                val.ticked = true;
                                $scope.outputLanguage.push(val);
                            }
                        }
                    }) 
                })

                $scope.channels = [];
                var nextPendingInfluencerChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.influencerId;
                $http.get(nextPendingInfluencerChannelUrl, {loader: false})
                    .success(function(responseNextPendingInfluencerChannel){
                        angular.forEach(responseNextPendingInfluencerChannel.data, function(item) {
                            $scope.channels.push(item);
                        })
                    });

               
                $scope.PlatformIcon = function (platform_id) {
                    return adminService.getPlatformIcon(platform_id);
                }

                $scope.dismissReasons.forEach(function (val) {
                    val.ticked = false;
                });
            }
        })
        .error(function (responseNextInf) {
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = responseNextInf.message;
        });
    }

    $scope.inactive = function (blog_id) {
        $scope.setSelectedDismissReason();
        $scope.setSelectedCountry();
        $scope.setSelectedLanguages();

        var notApprovedData = {
            blog_id: blog_id,
            domain: $scope.domain,
            country: $scope.selectedCountry,
            languages: $scope.selectedLanguages,
            reason: $scope.selectedReason
        }

        adminService.setInactiveInfluencer(notApprovedData, true)
            .then(function(responsesetInactiveInfluencer) {
                $scope.handleChannels(blog_id, responsesetInactiveInfluencer.influencer_management_log_id);
                $scope.getNextNewInfluencer();
            }, function(responsesetInactiveInfluencer) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responsesetInactiveInfluencer.message;
            });
    }

    $scope.active = function (blog_id) {
        $scope.setSelectedCountry();
        $scope.setSelectedLanguages();

        var approveNActiveData = {
            blog_id: blog_id,
            domain: $scope.domain,
            country: $scope.selectedCountry,
            languages: $scope.selectedLanguages
        }

        adminService.setActiveInfluencer(approveNActiveData, true)
            .then(function(responsesetActiveInfluencer) {
                $scope.handleChannels(blog_id, responsesetActiveInfluencer.influencer_management_log_id);
                $scope.getNextNewInfluencer();
            }, function(responsesetActiveInfluencer) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responsesetActiveInfluencer.message;
            });
    }

    $scope.removeChannelFromDB = function(influencer_management_log_id) {
        angular.forEach($scope.removeChannels, function(item){
            var deleteChannelData = {
                id: item.id,
                handle: item.handle,
                blog_id: item.blog_id,
                platform_id: item.platform_id,
                influencer_management_log_id: influencer_management_log_id
            }

            var req = {
                url: $rootScope.apiUrl + 'channel/deleteChannel',
                method: 'POST',
                data: deleteChannelData
            }    

            $http(req).success(function(responseChannelRemoval){

            })
                .error(function(responseChannelRemoval){
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseChannelRemoval.message;
                })
        })          
    }

    $scope.editChannelInDB = function(influencer_management_log_id) {
        angular.forEach($scope.editChannels, function(item){
            var editChannelData = {
                id: item.id,
                handle: item.handle,
                type: item.type,
                platform_id: item.platform_id,
                youtubeType: item.youtubeType,
                influencer_management_log_id: influencer_management_log_id
            }

            var req = {
                url: $rootScope.apiUrl + 'channel/updateChannel',
                method: 'POST',
                data: JSON.stringify(editChannelData)
            }

            $http(req).success(function(responseEditChannel){

            })
                .error(function(responseEditChannel){
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseEditChannel.message;
                })
        })        
    }

    $scope.addNewChannelToDB = function(id, influencer_management_log_id) {
        angular.forEach($scope.addNewChannels, function(item){
            var newChanneldata = {
                id: null,
                handle: item.handle,
                type: item.type,
                platform_id: item.platform_id,
                blog_id: id,
                youtubeType: item.youtubeType,
                influencer_management_log_id: influencer_management_log_id
            }

            var req = {
                url: $rootScope.apiUrl + 'channel/addChannel',
                method: 'POST',
                data: JSON.stringify(newChanneldata)
            }

            $http(req).success(function(responseAddNewChannel){

            })
                .error(function(responseAddNewChannel){
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseAddNewChannel.message;
                })
        })         
    }

    $scope.handleChannels = function(id, influencer_management_log_id) {
        if($scope.removeChannels != null && $scope.removeChannels.length > 0){
            $scope.removeChannelFromDB(influencer_management_log_id);        
        }
        if($scope.editChannels != null && $scope.editChannels.length > 0){
            $scope.editChannelInDB(influencer_management_log_id);
        }
        if($scope.addNewChannels != null && $scope.addNewChannels.length > 0){
            $scope.addNewChannelToDB(id, influencer_management_log_id);
        }
    }   

    $scope.checkDuplicateChannel = function(channel, channelList){
        angular.forEach(channelList, function(item){
            if(channel.handle == item.handle && channel.platform_id == item.platform_id){
                $scope.isValidToAdd = false;
            }
        });
    }

    $scope.newChannelModalHandler = function () {
        var channelModalInstance = $modal.open({       
            scope: $scope,    
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
            controller: 'NewChannelCtrl'
        });

        $scope.channelModalInstance = channelModalInstance;
        $scope.index = null;
        channelModalInstance.result.then(function(result){
            var isValidToAdd = true;
            if($scope.channels){
                if (result) {
                    $scope.checkDuplicateChannel(result.newChannel, $scope.channels);
                    if($scope.isValidToAdd ){
                        $scope.channels.push(result.newChannel);
                    }   
                    $scope.isValidToAdd = true;
                    $scope.checkDuplicateChannel(result.newChannel, $scope.addNewChannels);
                    if($scope.isValidToAdd){
                        $scope.addNewChannels.push(result.newChannel);
                    }
                    $scope.isValidToAdd = true;
                }    
            }                      
        },function(){
            //
        });
    }
    
    $scope.editChannelModalHandler = function(index){
        var channelModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
            controller: 'NewChannelCtrl' 
        })

        $scope.channelModalInstance = channelModalInstance;
        $scope.index = index;

        var indexNo = $scope.channels.indexOf(index);

        channelModalInstance.result.then(function(result){
            if (result) {
                $scope.checkDuplicateChannel(result.newChannel, $scope.channels);
                if($scope.isValidToAdd){
                    if (~indexNo) {
                        $scope.channels.splice(indexNo, 1,result.newChannel);
                    }
                }
                $scope.isValidToAdd = true;

                $scope.checkDuplicateChannel(result.newChannel, $scope.tempEditChannels);
                if($scope.isValidToAdd){
                    $scope.editChannels.push(result.newChannel);
                    $scope.channels.splice(indexNo, 1,result.newChannel);
                }
                $scope.isValidToAdd = true;
                $scope.index = null;
            }   
        })

    }

    $scope.removeChannel = function(index){
        var indexNo = $scope.channels.indexOf(index);
        if (~index) {
            $scope.channels.splice(indexNo, 1);
        }
        if(index.id != null){
            $scope.removeChannels.push(index);
        }        
    }

    $scope.closeModal = function(){
        $modalInstance.close();    
    }

    $scope.$watch('selectedCountry', function(newValue, oldValue){
        $scope.new_language_id = "";

        if(newValue !== oldValue && newValue !== undefined && $scope.enableWatch){
            console.log(newValue[0]);
            $scope.new_language_id = newValue[0] !== undefined ? newValue[0].id : null;
            if($scope.new_language_id != null) {
                var getCountryLanguageUrl = $rootScope.apiUrl + 'admin/getCountryLanguage?country_id=' + $scope.new_language_id;
                $http.get(getCountryLanguageUrl, {loader: false})
                    .success(function(responseCountryLanguage){
                        $scope.languages.forEach(function (defaultLang) {
                            defaultLang.ticked = false;
                            if (defaultLang.id == responseCountryLanguage.data.id) {
                                defaultLang.ticked = true;
                            }
                        }) 
                    }) 
            }                                                 
        }
    }); 

})
